import React from 'react'
import { Overlay } from '../components/Overlay/Overlay'

export const withOverlay = (component, withOverlay, styles, ...rest) => (
	<div {...rest} style={{ position: 'relative', display: 'grid', ...styles }}>
		{withOverlay && <Overlay />}
		{component}
	</div>
)
